// ** Custom Components
import Block from "components/layout/Block";

// ** Styled Components
import { StyledProgressBarWrapper } from "./styles/ProgressBarWrapper.styled";
import { StyledProgressBarSection } from "./styles/ProgressBarSection.styled";
import { StyledProgressBarPercent } from "./styles/ProgressBarPercent.styled";

// ** Redux
import { useSelector } from "react-redux";

// #####################################################

const ProgressBar = ({ currentStep, totalSteps, isModal }) => {
	const percentOfProgress = Math.ceil((100 * currentStep) / totalSteps);
	const rows = [];
	for (let i = 1; i <= totalSteps; i++) {
		rows.push(
			<StyledProgressBarSection
				sectionChecked={currentStep >= i}
				key={`progressBar_currentStep_${currentStep}_index_${i}`}
			/>
		);
	}

	// ** A/B Tests
	const authModalVersion = useSelector(
		(state) => state.globalCommon.authModal.version
	);

	// #####################################################

	return (
		<Block flex full alignCenter mb={5} pt={3}>
			<StyledProgressBarWrapper
				totalSteps={totalSteps}
				$isModal={isModal}
				$authModalVersion={authModalVersion}
			>
				{rows}

				<StyledProgressBarPercent
					position={Math.ceil(percentOfProgress / 2)}
				>
					{percentOfProgress}%
				</StyledProgressBarPercent>
			</StyledProgressBarWrapper>
		</Block>
	);
};

// #####################################################

export default ProgressBar;

// #####################################################
